import ThinLeftAngle from "@svg/thin-left-angle";
import classNames from "classnames";
import { Children, Fragment, ReactNode } from "react";

interface Props {
  suffix?: ReactNode;
  className?: string;
  isFullWidth?: boolean;
  children?: ReactNode;
}
const BreadcrumbContainer: React.FC<Props> = ({
  children,
  suffix,
  className,
  isFullWidth,
}) => {
  const childrenArray = Children.toArray(children);

  const childrenWithSeparator = childrenArray.map((child, index) => {
    if (index !== childrenArray.length - 1) {
      return (
        <Fragment key={index}>
          {child}
          <li className="mx-4">
            <ThinLeftAngle className="text-[#A1A1AA]" width={12} height={12} />
          </li>
        </Fragment>
      );
    }
    return child;
  });

  return (
    <nav
      className={classNames(
        "py-4 bg-white border-b border-[#e1e4e8]",
        className,
      )}
    >
      <div
        className={classNames(" flex justify-between items-center h-full", {
          "container-bs": !isFullWidth,
        })}
      >
        <ol className="flex items-center overflow-auto no-scrollbar h-full">
          {childrenWithSeparator}
        </ol>
        {suffix}
      </div>
    </nav>
  );
};

export default BreadcrumbContainer;
